// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__taOJB","content":"About_content__hgJeq","title":"About_title__S-jAL","text":"About_text__5cvI5"};